import { AbstractGameService } from '../../core/abstraction/AbstractGameService';
import {
  getBonusSpinUrl,
  getBuyBonusUrl,
  getInitialStateUrl,
  getPreBonusSpinUrl,
  getSpinUrl,
} from '../../core/endponts';
import { httpClient } from '../../core/httpClient';
import { crystalTypes } from '../../core/gameConstants';

export class DemoGameStrategy extends AbstractGameService {
  async spin(body) {
    return await httpClient.post(getSpinUrl({ isDemo: true }), body).then(res => {
      return {
        ...res,
        result: res.demoBonusId ? crystalTypes.crystal_gold : res.result,
      }
    });
  }

  async bonusSpin(body) {
    return await httpClient.post(getBonusSpinUrl({ isDemo: true }), body);
  }

  async preBonusSpin(body) {
    return await httpClient.post(getPreBonusSpinUrl({ isDemo: true }), body);
  }

  async buyBonus(body) {
    return await httpClient.post(getBuyBonusUrl({ isDemo: true }), body);
  }

  async getInitialState(params) {
    return await httpClient.get(getInitialStateUrl({ isDemo: true }), {
      params,
    });
  }
}
